angular.module('lead')
    .controller('LeadImportController', function ($cookies, $scope, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
        let onSaveError = () => {
            $scope.isSaving = false;
        };
        let onSaveSuccess = result => {
            toastr.success("Zapisano");
            $rootScope.$broadcast('lead.updated');
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };
        $scope.types = ["CSV", "CSV-SIMPLE"];

        $scope.import = {
            type: "CSV",
            charset: "CP1250",
            createRelatives: false
        };
        $scope.data = [];

        $scope.cancel = () => $uibModalInstance.dismiss('Canceled');

        $scope.uploader = createUploader();

        $scope.save = () => {
            if ($scope.isSaving)
                return;
            $scope.isSaving = true;
            $http.post('/crm/api/lead-batch/save-data', {items: $scope.data, createRelatives: $scope.import.createRelatives}).then(onSaveSuccess, onSaveError);
        };

        function createUploader() {
            let uploader = new FileUploader({
                url: '/crm/api/lead-batch/read-data',
                autoUpload: true,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            });
            uploader.onSuccessItem = (fileItem, response, status, headers) => {
                toastr.success("Wczytano dane z pliku");
                $scope.data = response;
                angular.element("input[type='file']").val(null);
            };
            uploader.onErrorItem = (fileItem, rejection, status, headers) => {
                if (angular.isArray(rejection.messages)) {
                    angular.forEach(rejection.messages, (message, key) => toastr.error(message));
                }
            };
            uploader.onBeforeUploadItem = function (item) {
                item.formData.push($scope.import);
            };
            return uploader;
        }
    })
